import Board from "./components/Board.jsx";
import "./App.css";
function App() {
  return(
    <>
      <Board/>
    </>
  )
}

export default App;
